module.exports = __webpack_public_path__ + "img/hl_common.a550a4a0.png";